import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: 'space-around',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}))

export default useStyles
